module.exports = __webpack_public_path__ + "img/icon_map_5_yj.d7eb522a.png";